import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';


@Injectable()
export class WeSafeHttpInterceptor implements HttpInterceptor {

  constructor() { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      
    const isLoginApi =  req.url.includes('auth') || req.url.includes('resetlink') || req.url.includes('add-or-update-WorkPermit-contractor') ||  req.url.includes('getWorkPermitById') || req.url.includes('WorkPermitApproval') || req.url.includes('contractorHotWorkPermit') || req.url.includes('contractorColdWorkPermit');
    if(isLoginApi) {
      return next.handle(req);
    }
    

    const token = localStorage.getItem('accessToken');
    const refreshToken = localStorage.getItem('refreshToken');
    const reqWithAuth = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
    return token ? next.handle(reqWithAuth) : next.handle(req);
  }
}
